{
  "SET_NEW_PASSWORD": {
    "TITLE": "Nastaviť nové heslo",
    "PASSWORD": {
      "LABEL": "Heslo",
      "PLACEHOLDER": "Heslo",
      "ERROR": "Heslo je príliš krátke."
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "Potvrdiť heslo",
      "PLACEHOLDER": "Potvrdiť heslo",
      "ERROR": "Heslá sa nezhodujú."
    },
    "API": {
      "SUCCESS_MESSAGE": "Heslo bolo úspešne zmenené.",
      "ERROR_MESSAGE": "Nepodarilo sa pripojiť k chatovaciemu serveru. Skúste to prosím znova."
    },
    "CAPTCHA": {
      "ERROR": "Overenie vypršalo. Vyriešte prosím captcha znova."
    },
    "SUBMIT": "Odoslať"
  }
}
